import type { ApiUserEnvironmentOrgMini } from '#/api/userEnvironment/types/ApiUserEnvironmentOrgMini';

import { PostAListingPageButton } from './Button/PostAListingPageButton';
import { getPostAListingPageCreateListingPath } from './getPostAListingPageCreateListingPath';

type Props = {
  orgs: ApiUserEnvironmentOrgMini[];
  from: string | null | undefined;
  listingType?: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT';
};

export function PostAListingPageOrgList({ orgs, from, listingType }: Props) {
  return (
    <>
      {orgs.map((org) => {
        const isAllowedToPost = org.isAllowedToPost && !org.isFrozen;

        return (
          <PostAListingPageButton
            key={org.id}
            type="link-with-state"
            qaId="org-link"
            to={getPostAListingPageCreateListingPath({
              orgId: org.id,
              listingType,
              isAllowedToPost,
            })}
            state={{ from }}
            fromVM={org.fromVm}
          >
            {org.name}
          </PostAListingPageButton>
        );
      })}
    </>
  );
}
